import monthlyCosts from './monthlyCosts'
import oneTimeCosts from './oneTimeCosts'

export default (form, year) => (
  monthlyCosts(form, year) + oneTimeCosts(form, year)
)
